import { render, staticRenderFns } from "./DictationButton.vue?vue&type=template&id=5cfe253d&scoped=true"
import script from "./DictationButton.vue?vue&type=script&lang=js"
export * from "./DictationButton.vue?vue&type=script&lang=js"
import style0 from "./DictationButton.vue?vue&type=style&index=0&id=5cfe253d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfe253d",
  null
  
)

export default component.exports